import XHR from 'bpm-xhr';

import { bindEvents } from '../../../assets/js/helpers';

import AnimationController from '../../../assets/js/controller/animation';
import ResizeController from '../../../assets/js/controller/resize';

const selector = 'form-sign-in';

export default class FormSignIn {

	constructor(section) {
		this.el = {
			section,

			body: document.querySelector('body'),
			smiley: document.querySelector(`.${selector}__smiley`),

			form: section.querySelector('form'),
			inputs: section.querySelectorAll('input'),
			measureInput: section.querySelector(`.${selector}__measure-input`),

			submit: section.querySelector(`.${selector}__submit`)
		};

		// class variable groups

		this.controllers = {
			animation: null,
			resize: null
		};

		this.smiley = {
			position: [0, 0],
			direction: [1, 1],
			frame: null
		};

		// class variables

		this.visible = false;

		this.focusTimer = null;

		// bind events to class scope
		this.events = bindEvents(this);

		// mosey
		this.init();
	}

	static get selector() {
		return selector;
	}

	init() {
		this.addEventListeners();
	}

	// event listeners

	addEventListeners() {
		this.controllers.resize = AnimationController.set({
			update: () => { this.events._onAnimateUpdate(); },
			resize: () => { this.events._onAnimateRender(); }
		});

		this.controllers.resize = ResizeController.set({
			update: () => { this.events._onResizeUpdate(); },
			resize: () => { this.events._onResizeRender(); }
		});

		this.el.form.addEventListener('submit', this.events._onFormSubmit);
		this.el.submit.addEventListener('click', this.events._onSubmitClick);

		for (const i of this.el.inputs) {
			i.addEventListener('focus', this.events._onInputFocus);
			i.addEventListener('input', this.events._onInputInput);
			i.addEventListener('blur', this.events._onInputBlur);
		}

		this.setAllInputs();
	}

	removeEventListeners() {
		ResizeController.clear(this.controllers.resize);

		this.el.form.removeEventListener('submit', this.events._onFormSubmit);
		this.el.submit.removeEventListener('click', this.events._onSubmitClick);

		for (const i of this.el.inputs) {
			i.removeEventListener('focus', this.events._onInputFocus);
			i.removeEventListener('input', this.events._onInputInput);
			i.removeEventListener('blur', this.events._onInputBlur);
		}
	}

	// listener methods

	_onFormSubmit(e) {
		e.preventDefault();

		let isValid = true;

		for (const i of this.el.inputs) {
			if (!i.validity.valid) {
				isValid = false;
			}
		}

		if (isValid) {
			const formData = new FormData(e.target);
			new XHR('json')
				.post('/php/event-sign-in.php', formData)
				.then((xhr) => {
					if (xhr.response.status.code === 200) {
						// success!
						this.el.section.classList.remove('is-submit-error');
						this.el.section.classList.add('is-submit-success');

						setTimeout(() => {
							location.reload();
						}, 1000);
					} else {
						// failure
						this.el.section.classList.remove('is-submit-success');
						this.el.section.classList.add('is-submit-error');
					}
				});
		}
	}

	_onSubmitClick() {
		this.el.section.classList.add('is-submit-clicked');
	}

	// controller listeners

	_onResizeUpdate() {
		this.setAllInputs();
	}

	_onResizeRender() {

	}

	_onAnimateUpdate() {

	}

	_onAnimateRender() {

	}

	// input listeners

	_onInputFocus(e) {
		if (!e.target.value) this.setInputWidth(e.target, '');
	}

	_onInputInput(e) {
		e.target.classList[e.target.value ? 'add' : 'remove'](`${selector}--value`);
		this.setInputWidth(e.target, e.target.value);
	}

	_onInputBlur(e) {
		if (!e.target.value) this.setInputWidth(e.target, e.target.getAttribute('data-placeholder'));
	}

	// input methods

	measureInput(value) {
		this.el.measureInput.innerText = value.replace(/ /g, '\u00a0');
		return Math.ceil(this.el.measureInput.offsetWidth);
	}

	setInputWidth(input, value) { // eslint-disable-line
		// const el = input;
		// const width = this.measureInput(value) + 15;
		// el.style.width = `${width}px`;
	}

	setAllInputs() {
		for (const i of this.el.inputs) {
			this.setInputWidth(i, i.value || i.getAttribute('data-placeholder'));
		}
	}

	toggle() {
		if (!this.visible) {
			this.el.body.classList.add('form-visible');
			this.visible = true;
			this.stopSmiley();
		} else {
			this.el.body.classList.remove('form-visible');
			this.visible = false;
		}
	}

	emptyInputs() {
		for (const i of this.el.inputs) {
			i.value = '';
			i.classList.remove(`${selector}--value`);
			this.setInputWidth(i, i.getAttribute('data-placeholder'));
			i.blur();
		}
	}

	// smiley animation

	startSmiley() {
		const width = this.el.smiley.clientWidth;
		const height = this.el.smiley.clientHeight;
		this.smiley.position[0] = Math.round(Math.random() * (window.innerWidth - width));
		this.smiley.position[1] = Math.round(Math.random() * (window.innerHeight - height));
		this.smiley.direction[0] = Math.random() >= 5 ? 1 : -1;
		this.smiley.direction[1] = Math.random() >= 5 ? 1 : -1;
		this.el.smiley.style.transform = `translate(${this.smiley.position[0]}px, ${this.smiley.position[1]}px)`;
		this.el.body.classList.add(`${selector}--visible-smiley`);
		this.moveSmiley();
	}

	moveSmiley() {
		this.smiley.frame = requestAnimationFrame(() => this.moveSmiley());
		this.smiley.position[0] += this.smiley.direction[0] * 2;
		this.smiley.position[1] += this.smiley.direction[1] * 2;
		this.el.smiley.style.transform = `translate(${this.smiley.position[0]}px, ${this.smiley.position[1]}px)`;
		if (this.smiley.position[0] + this.el.smiley.clientWidth >= window.innerWidth) {
			this.smiley.direction[0] = -1;
		} else if (this.smiley.position[0] < 0) {
			this.smiley.direction[0] = 1;
		}
		if (this.smiley.position[1] + this.el.smiley.clientHeight >= window.innerHeight) {
			this.smiley.direction[1] = -1;
		} else if (this.smiley.position[1] < 0) {
			this.smiley.direction[1] = 1;
		}
	}

	stopSmiley() {
		if (this.smiley.frame) cancelAnimationFrame(this.smiley.frame);
		this.el.body.classList.remove(`${selector}--visible-smiley`);
	}

	// destroy

	destroy() {
		this.removeEventListeners();
	}

}
